import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ContactHero } from '../components/contact/ContactHero';
import { ContactCTA } from '../components/contact/ContactCTA';
import { ContactDetails } from '../components/contact/ContactDetails';
export function ContactPage() {
  return <div className="min-h-screen bg-brand-cream font-body text-brand-text selection:bg-brand-gold selection:text-white overflow-x-hidden" data-id="element-2307">
      <Header data-id="element-2308" />
      <main data-id="element-2309">
        <ContactHero data-id="element-2310" />
        <ContactCTA data-id="element-2311" />
        <ContactDetails data-id="element-2312" />
      </main>
      <Footer data-id="element-2313" />
    </div>;
}